module.exports = __webpack_public_path__ + "img/AdobeStock_265143893.a617b0df.jpeg";